<template>
  <sModal
    v-model="valueMutable"
    :body-style="'padding: 0; overflow: hidden;'"
    :closable="false"
    :content-classes="contentClass"
    footer-hide
    :fullscreen="fullscreen"
    transfer>
    <template #activator="slotProps">
      <slot
        name="activator"
        v-bind="{
          ...slotProps,
          on: {
            click: () => { valueMutable = true }
          }
        }"/>
    </template>
    <slot/>
  </sModal>
</template>
<script>
/**
компонент используется для замены v-dialog с fullscreen
в тех местах, где нужно, чтобы модальное окно занимало весь экран, при этом не ломая логику передачи пропсов из родительского компонента,
который может использовать как v-dialog, так и ModalFullScreen в зависимости от условий
*/
export default {
  name: 'modalFullScreen',
  data() {
    return {}
  },
  methods: {},
  computed: {
    valueMutable: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  props: {
    value: Boolean,
    contentClass: String,
    fullscreen: Boolean,

    noClickAnimation: Boolean, // просто заглушка, так как в sModal нет такой пропсы, но чтобы не ломать логику передачи пропсов из родительского компонента
    persistent: Boolean // просто заглушка, так как в sModal нет такой пропсы, но чтобы не ломать логику передачи пропсов из родительского компонента
  },
  watch: {
    valueMutable: {
      immediate: true,
      handler(val) {
        if (val) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      }
    }
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  },
}
</script>